/* eslint-disable react/sort-comp */
import React from 'react'
import PropTypes from 'prop-types'
import * as d3 from 'd3-sankey-circular'
import Link from './Link'
import Rect from './Rect'
import * as _ from 'lodash'

class SankeyChart extends React.Component {
  static propTypes = {
    nodes: PropTypes.array,
    links: PropTypes.array,
    size: PropTypes.object
  }

  static NODE_TYPES = {
    first: 0,
    include: 1,
    last: 2
  }

  constructor(props) {
    super(props)
    this.svgRef = React.createRef()
    this.state = {
      svgHeight: 0
    }
  }

  componentDidMount() {
    this.updateSVGSize()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.nodes !== this.props.nodes || prevProps.links !== this.props.links) {
      this.updateSVGSize()
    }
  }

  updateSVGSize = () => {
    const {size} = this.props
    const {svgHeight} = this.state
    if (this.svgRef.current) {
      const bbox = this.svgRef.current.getBBox()
      const newHeight = bbox.height > size.height ? bbox.height : size.height
      if (newHeight === svgHeight) {
        return
      }

      this.setState({
        svgHeight: newHeight
      })
    }
  }

  render() {
    const {svgHeight} = this.state
    const {size} = this.props
    const nodesData = this.props.nodes
    const linksData = this.props.links

    const {links, nodes} = d3
      .sankeyCircular()
      .nodeId(node => node['name'])
      .nodeAlign(node => {
        return SankeyChart.NODE_TYPES[node['sessionType']]
      })
      .nodeWidth(410)
      .nodePadding(0)
      .extent([
        [0, 20],
        [size.width, svgHeight]
      ])({nodes: nodesData, links: linksData})

    const nodeGroup = _.groupBy(nodes, 'column')

    const padding = (size.width - _.keys(nodeGroup).length * 410) / (_.keys(nodeGroup).length + 1)

    let maxHeight = 200
    _.map(nodeGroup, nodes => {
      nodes = _.orderBy(nodes, 'y0')
      const minY0 = _.minBy(nodes, 'y0').y0
      _.map(nodes, (node, index) => {
        console.log(node)
        if (node.column === 0) {
          node.x0 = padding
          node.x1 = node.x0 + 410
        } else if (node.column === 1 || _.keys(nodeGroup).length === 2) {
          node.x0 = 2 * padding + 410
          node.x1 = node.x0 + 410
        } else if (node.column === 2) {
          node.x0 = 3 * padding + 410 * 2
          node.x1 = node.x0 + 410
        }
        
        if (index === 0) {
          node.y0 = node.y0 - minY0 + 20
          node.y1 = node.y0 + 8
        } else {
          const preNodeY1 = nodes[index - 1].y1
          node.y0 = preNodeY1 + 110
          node.y1 = node.y1 = node.y0 + 8
        }
      })

      const maxHeightGroup = _.last(nodes, 'y1').y1

      maxHeight = maxHeightGroup > maxHeight ? maxHeightGroup : maxHeight
    })

    setTimeout(() => {
      try {
        this.updateSVGSize()
      } catch (e) {
        // ignore
      }
    }, 0)

    return (
      <svg
        width={size.width}
        height={maxHeight + 120}
        className='sankey-chart'
      >
        {/* <g>
          {links.map((d, i) => (
            <Link key={i} data={d} width={d.width} length={nodes.length} />
          ))}
        </g> */}
        <g ref={this.svgRef}>
          {nodes.map((d, i) => (
            <Rect key={i} data={d} />
          ))}
        </g>
      </svg>
    )
  }
}
export default SankeyChart



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggrChart/SankeyChart/SankeyChart.js